/**
 * Inject "__RequestVerificationToken" header needed by Kentico against
 * Cross-Site Request Forgery.
 */
const getCSRFToken = () => {
  const token = (window.WIDGETS_CONFIG?.general as General)?.requestVerificationToken ?? "";

  if (!token) {
    console.error('Missing "requestVerificationToken" in general config!');
  }

  return token;
};

export default getCSRFToken;